import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row mt-4" }
const _hoisted_2 = { class: "col-md-12 text-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-12" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-12" }
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = { class: "col-md-12 mt-3 mb-5" }

import { reactive, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";

//services
import * as clienteService from "@/services/clienteService";
import {f2dec, fdata} from "@/utils/funcoes";
import imgLogin from "@/assets/images/logoLogin.png";
import imgSemImagem from "@/assets/images/sem-imagem.gif";


export default /*@__PURE__*/_defineComponent({
  __name: 'Parceiro',
  setup(__props) {

//vue
const controle = reactive({
  parceiro: null as clienteService.Parceiro | null,
  status: "" as string,
  erro: "" as string
});

const route = useRoute();

onMounted(() => {
    console.log("Mounted Parceiro.vue");
    if (route.params.parceiroId) {
        const parceiroId = Number(route.params.parceiroId);
        controle.status = "Buscando parceiro...";
        console.log("parceiroId:", parceiroId);
        clienteService.obterParceiros({ parceiroId: parceiroId } as clienteService.ClienteParceirosFiltros)
            .then((r) => {
                controle.status = "";
                controle.parceiro = r.dados[0];
            })
            .catch((error) => {
                console.error("Erro ao buscar parceiro:", error);
                controle.status = "";
                controle.erro = error.message || "Erro desconhecido";
            });
    } else {
        controle.erro = "ID do parceiro não fornecido na URL.";
    }
});


function sair() {
    // Lógica para sair da área do cliente
    controle.status = "Saindo...";
    console.log("Saindo da área do cliente...");
    localStorage.removeItem("clienteToken");
    window.location.reload();
}


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _unref(imgLogin),
          alt: "Logo",
          class: "img-fluid img-logo mb-3"
        }, null, 8, _hoisted_3)
      ])
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "row mt-4 mb-3" }, [
      _createElementVNode("div", { class: "col-md-12" }, [
        _createElementVNode("h2", null, "Parceiro")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (controle.erro == '')
          ? (_openBlock(), _createElementBlock("h4", _hoisted_6, _toDisplayString(controle.status), 1))
          : _createCommentVNode("", true),
        (controle.erro != '')
          ? (_openBlock(), _createElementBlock("h4", _hoisted_7, _toDisplayString(controle.erro), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("h3", null, _toDisplayString(controle.parceiro?.nome), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", null, " Desconto Inicial: " + _toDisplayString(_unref(f2dec)(controle.parceiro?.valorDescontoIni)) + " %", 1),
        _createElementVNode("div", null, " Desconto : " + _toDisplayString(_unref(f2dec)(controle.parceiro?.valorDesconto)) + " %", 1),
        _createElementVNode("div", null, " Telefone: " + _toDisplayString(controle.parceiro?.telefone), 1),
        _createElementVNode("div", null, " Logradouro: " + _toDisplayString(controle.parceiro?.logradouro), 1),
        _createElementVNode("div", null, " Número: " + _toDisplayString(controle.parceiro?.numero), 1),
        _createElementVNode("div", null, " Bairro: " + _toDisplayString(controle.parceiro?.bairro), 1),
        _createElementVNode("div", null, " CEP: " + _toDisplayString(controle.parceiro?.cep), 1),
        _createElementVNode("div", null, " Cidade: " + _toDisplayString(controle.parceiro?.cidade?.nome), 1),
        _createElementVNode("div", null, " Estado: " + _toDisplayString(controle.parceiro?.cidade?.estado), 1),
        _createElementVNode("div", null, " CEP: " + _toDisplayString(controle.parceiro?.cep), 1),
        _createElementVNode("div", null, " CNPJ/CPF: " + _toDisplayString(controle.parceiro?.cnpj), 1),
        _createElementVNode("div", null, " Responsável: " + _toDisplayString(controle.parceiro?.responsavel), 1),
        _createElementVNode("div", null, " Texto: " + _toDisplayString(controle.parceiro?.texto), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_RouterLink, {
          class: "btn btn-secondary btn-sm mb-5",
          to: "/cliente"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("i", { class: "flaticon-left-arrow" }, null, -1),
            _createTextVNode(" Voltar ", -1)
          ]))]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})